import { render, staticRenderFns } from "./reporte_cxc.vue?vue&type=template&id=5cfcc008&scoped=true&"
import script from "./reporte_cxc.vue?vue&type=script&lang=js&"
export * from "./reporte_cxc.vue?vue&type=script&lang=js&"
import style0 from "./reporte_cxc.vue?vue&type=style&index=0&id=5cfcc008&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cfcc008",
  null
  
)

export default component.exports